import { Button } from "@material-ui/core";
import ClearAllIcon from "@material-ui/icons/ClearAll";
import React from "react";
import { FormattedMessage } from "react-intl";
import styled from "styled-components";

const StyledButton = styled(Button)`
  text-transform: none;
  font-weight: 400;
  height: 2rem;
  padding: 0 0.875rem;
  font-size: 0.9375rem;
  line-height: 1;
`;

interface IClearFiltersButtonProps {
  onClick: () => void;
}

const ClearFiltersButton = (props: IClearFiltersButtonProps) => {
  const { onClick } = props;

  return (
    <StyledButton
      color="primary"
      variant="text"
      startIcon={<ClearAllIcon />}
      onClick={onClick}
    >
      <FormattedMessage
        id="EmployeesFilters.ClearFilters"
        defaultMessage="Limpiar filtros"
      />
    </StyledButton>
  );
};

export default ClearFiltersButton;
